<template>
  <img
    v-if="user.profile_img"
    :src="user.profile_img"
    alt="altText"
    class="avatar-profile avatar-circle"
    @click.stop="userClick"
  />
  <el-button
    v-else-if="user.firstname"
    :class="classList"
    @click.stop="userClick"
    class="display-inline-block uppercase avatar-circle cursor-pointer"
    type="text"
    circle
    >{{ `${user.firstname[0]} ${user.lastname[0]}` }}</el-button
  >
  <span v-else class="display-inline-block box unassigned" @click.stop="userClick">
    <i class="fal fa-user-circle cursor-pointer"></i>
  </span>
</template>
<script>
export default {
  name: 'UserButton',
  props: {
    user: {
      type: Object,
      default: () => {
        return { firstname: '', lastname: '', email: '', fullname: '' }
      }
    },
    classList: { type: String }
  },
  methods: {
    userClick () {
      this.$emit('button-click')
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.avatar-profile {
  line-height: 32px;
  vertical-align: bottom;
  border-radius: 50%;
}

.avatar-circle {
  color: white;
  letter-spacing: -1px;
  font-size: 13px;
  height: 32px;
  width: 32px;
  padding: 0px;
  position: relative;

  &.active {
    border: 2px solid white;
  }
  &.active::after {
    content: '';
    border: 2px solid #197de6;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    position: absolute;
    left: -4px;
    top: -4px;
  }
}

.unassigned {
  font-size: 2.25em;
  opacity: 0.5;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/button/UserButton.vue